import { GoogleOAuthProvider } from '@react-oauth/google';
import { ReactNode, useEffect } from "react"
import { useArticleRestriction } from "../../../global/paywall/useArticleRestriction";


interface PayWallWrapperProps {
  resourceId: string;
  children: ReactNode;
}

declare const window: Window & {
  PAYWALL_GOOGLE_CLIENT_ID: string
}

const GOOGLE_CLIENT_ID = typeof window !== "undefined" && window && window.PAYWALL_GOOGLE_CLIENT_ID || " ";

export const PayWallWrapper = (props: PayWallWrapperProps) => {
  let { resourceId } = props

  const isPayWallActive = useArticleRestriction({ free: 'freePass', premium: 'plus' }, resourceId);

  useEffect(() => {
    if (isPayWallActive){
      cutArticlePremiumContent();
    }
  }, [isPayWallActive])

  if (!isPayWallActive) {
    return null;
  } 

  return (
    <div className="paywall-wrapper">
      <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
        <div className="ArticlePremiumCutter" id="ynet_premium_blocked">
          <div className="yedioth-plus-logo"></div>
          <div className="premium_block">
            {props.children}
          </div>
        </div>
      </GoogleOAuthProvider>
    </div>
  );
};



export const cutArticlePremiumContent = () => {
  const container = document.querySelector('.public-DraftEditor-content [data-contents="true"]');
  if (!container) return;
  const paywall = container.querySelector(".text_editor_paragraph .paywall-wrapper");
  if (!paywall) return;
  const paywallParagraph = paywall.closest(".text_editor_paragraph");
  if (!paywallParagraph) return;
  container.innerHTML = "";
  container.appendChild(paywallParagraph);
  const cutPremiumEvent  = new Event("onCutArticlePremiumContent")
  document.dispatchEvent(cutPremiumEvent);
};


